module.exports = __webpack_public_path__ + "static/media/clock.e89761f3.svg";